/**
 * Флаг cross-unit сценариев (6-7) на стороне браузера.
 *
 * АВТОРИТЕТНЫЙ гейт — серверный: сервис аномалий проверяет
 * ENABLE_CROSS_UNIT_SCENARIOS и при выключенном флаге возвращает конверт
 * CROSS_UNIT_SCENARIOS_DISABLED, не открывая сокет к бэкенду кандидатов.
 * Клиентский флаг — только UI-удобство: он не может ни открыть доступ к данным,
 * ни заменить серверную проверку.
 *
 * ОТЛИЧИЕ ОТ ИСХОДНИКА (localhost:3009): там клиентский флаг по умолчанию
 * ВЫКЛЮЧЕН и включается переменной NEXT_PUBLIC_ENABLE_CROSS_UNIT_SCENARIOS.
 * В окружении фронта платформы такой переменной нет, а заводить её только ради
 * дублирования серверного гейта незачем: при выключенном сервере UI и так
 * покажет причину отказа из конверта. Поэтому здесь по умолчанию ВКЛЮЧЕНО, а
 * переменная оставлена аварийным выключателем — значение false/0/no/off прячет
 * сценарии 6-7 из UI без правки кода.
 */

export const CROSS_UNIT_FLAG_CLIENT = 'NEXT_PUBLIC_ENABLE_CROSS_UNIT_SCENARIOS'

/** Сценарии, которые обслуживает широкий каталог кандидатных пар. */
export const CROSS_UNIT_SCENARIO_IDS = [6, 7] as const
export type CrossUnitScenarioId = (typeof CROSS_UNIT_SCENARIO_IDS)[number]

/** Явное «выключено». Всё остальное, включая unset, выключением не считается. */
export function isFlagFalsy(raw: string | undefined | null): boolean {
  if (raw === undefined || raw === null) return false
  const s = String(raw).trim().toLowerCase()
  return s === '0' || s === 'false' || s === 'no' || s === 'off'
}

/**
 * Значение на клиенте. `process.env.NEXT_PUBLIC_*` должен читаться статически,
 * иначе компилятор Next не подставит значение в бандл — не переписывать на
 * динамический доступ.
 */
export function isCrossUnitEnabledClient(): boolean {
  return !isFlagFalsy(process.env.NEXT_PUBLIC_ENABLE_CROSS_UNIT_SCENARIOS)
}

/** Истинно только для 6/7 — никогда для 1–5 и никогда для нечислового сценария. */
export function isCrossUnitScenario(scenarioId: number | string | null | undefined): boolean {
  const n = typeof scenarioId === 'number' ? scenarioId : Number(scenarioId)
  return Number.isFinite(n) && (n === 6 || n === 7)
}
